import { ColorEnum } from '@/constants/color'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

interface TotalPriceProps {
    price: string
}

const TotalPrice: FC<TotalPriceProps> = ({ price }) => {
    const { t } = useTranslation()

    return (
        <View style={styles.container} testID="total-price">
            <Typography.Heading variant="h2" numberOfLines={1} style={styles.text}>
                {t('common.overview.prices.total')}
            </Typography.Heading>
            <Typography.Heading variant="h2" numberOfLines={1} style={styles.priceText}>
                {price}
            </Typography.Heading>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        maxWidth: '100%',
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: 12,
    },
    text: {
        color: ColorEnum.GRAY_900,
    },
    priceText: {
        color: ColorEnum.GRAY_900,
        flexShrink: 1,
        textAlign: 'right',
    },
})

export default TotalPrice
